import { PayoutFormContext } from 'modules/host-payout-methods/context/PayoutFormContext';
import { useContext, useEffect } from 'react';

const usePayoutMethods = () => {
  const { payoutMethods, actions } = useContext(PayoutFormContext);

  useEffect(() => {
    actions.fetchPayoutMethods();
  }, [actions]);

  return payoutMethods;
};

export default usePayoutMethods;
